module.exports = __webpack_public_path__ + "static/media/bench.d8c9c0fb.svg";